<template>
  <div
    :style="{ 'align-items': align }"
    class="grid"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CGrid',

  props: {
    align: {
      type: String,
      validator (value) {
        return [
          'center',
          'baseline',
          'end',
          'first baseline',
          'last baseline',
          'start',
          'stretch'
        ].indexOf(value) >= 0
      }
    }
  }
}
</script>

<style scoped>
@media (min-width: 600px) {
  .grid {
    display: grid;
    grid-column-gap: var(--grid-spacing);
    grid-template-columns: repeat(12, 1fr);
  }

  .grid > * {
    grid-column: span 12;
  }
}
</style>
